export default "/images/shield.svg?569925d19f647b2691a02ad86077625b";